<!-- [팝업] 관심 컨텐츠 항목 추가/수정 -->
<template>
  <b-modal
    v-model="showInterestContentEdit"
    cancel-variant="outline-secondary"
    centered
    ok-title="저장"
    cancel-title="취소"
    size="sm"
    :title="(isNew ? '항목 추가' : '항목 수정')"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <validation-observer ref="formRules">
      <b-row class="mt-1">
        <b-col
          cols="12"
        >
          <b-form-group
            label="항목명"
            label-for="interestContentTitle"
          >
            <validation-provider
              #default="{ errors }"
              name="항목명"
              rules="required"
            >
              <b-form-input
                id="interestContentTitle"
                v-model="interestContentData.title"
                placeholder="항목명을 입력하세요.(최대 20자)"
                maxlength="20"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
        >
          <b-form-group
            label="설명"
            label-for="interestContentDescription"
          >
            <b-form-textarea
              id="interestContentDescription"
              v-model="interestContentData.description"
              placeholder="설명을 입력하세요.(최대 60자)"
              maxlength="60"
              rows="3"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import { ref, watch, getCurrentInstance } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import { ValidationProvider, ValidationObserver } from "vee-validate"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter } from '@core/utils/filter'
import { cloneDeep } from 'lodash'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    showInterestContentEdit: {
      type: Boolean,
      required: true,
    },
    isNew: {
      type: Boolean,
      required: true,
    },
    editItem: {
      type: Object,
      required: false,
      default: null,
    },
  },

  setup(props, { emit }) {
    watch(
      () => props.editItem,
      newVal => {
        if (newVal) {
          interestContentData.value = cloneDeep(newVal)
        } else {
          interestContentData.value = interestContentInitState()
        }
      },
    )

    const toast = useToast()
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const interestContentInitState = () => ({
      id: null,
      title: null,
      description: null,
    })
    const interestContentData = ref(interestContentInitState())

    const submit = () => {
      const validPromise = refs.formRules.validate()
      validPromise.then(valid => {
        if (!valid) return

        if (!props.isNew && interestContentData.value.id) {
          updateInterestContent()
        } else {
          saveNewInterestContent()
        }
      })
    }

    const saveNewInterestContent = () => {
      try {
        axios.post("/fa/interest-content/new", interestContentData.value)
          .then(() => {
            pushToast('success', '신규 등록 완료')
            clear()
            emit('close', true)
          })
          .catch(error => {
            pushToast('danger', errorFormatter(error, "관심컨텐츠를 등록하는 과정에서 오류가 발생하였습니다."))
          })
      } catch (e) {
        pushToast('danger', errorFormatter(e, "관심컨텐츠를 등록하는 과정에서 오류가 발생하였습니다."))
      }
    }

    const updateInterestContent = () => {
      try {
        axios.patch('/fa/interest-content/update', interestContentData.value)
          .then(() => {
            pushToast('success', '데이터 변경 완료')
            clear()
            emit('close', true)
          })
          .catch(error => {
            pushToast('danger', errorFormatter(error, "관심컨텐츠를 변경하는 과정에서 오류가 발생하였습니다."))
          })
      } catch (e) {
        pushToast('danger', errorFormatter(e, "관심컨텐츠를 변경하는 과정에서 오류가 발생하였습니다."))
      }
    }

    const clear = () => {
      interestContentData.value = interestContentInitState()
    }

    const close = () => {
      refs.formRules.reset()
      clear()
      emit('close', null)
    }

    return {
      close,
      submit,
      interestContentData,
    }
  },
}
</script>
